var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.28 10.6328C13.1533 10.6328 13.0267 10.5862 12.9267 10.4862L8.58001 6.1395C8.26001 5.8195 7.74001 5.8195 7.42001 6.1395L3.07335 10.4862C2.88001 10.6795 2.56001 10.6795 2.36668 10.4862C2.17335 10.2928 2.17335 9.97283 2.36668 9.7795L6.71335 5.43283C7.42001 4.72617 8.57335 4.72617 9.28668 5.43283L13.6333 9.7795C13.8267 9.97283 13.8267 10.2928 13.6333 10.4862C13.5333 10.5795 13.4067 10.6328 13.28 10.6328Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.95d44d1ee757952df3b3ad3c2541e9c8.svg";
export { ForwardRef as ReactComponent };